import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Create = loadable(() => import('./Create'), {});
export const FormSelector = loadable(() => import('./FormSelector'), {});
export const InstitutionContractTemplateSelector = loadable(
  () => import('./InstitutionContractTemplateSelector'),
  {},
);
export const EnvelopeTemplateSelector = loadable(() => import('./EnvelopeTemplateSelector'), {});
export const GradeSelector = loadable(() => import('./GradeSelector'), {});
